/**
 * Used to login with email and password to firebase
 */
export type LoginRequest = {
	email: string;
	password: string;
};

/**
 * This is the response from firebase after login which we need to use to authenticate against the taxpeer backend
 */
export type LoginResponse = {
	token: string;
};

/**
 * Used to register with email and password to firebase
 */
export type RegisterRequest = {
	email: string;
	password: string;
};

/**
 * This is the response from firebase after registration which we need to use to authenticate against the taxpeer backend
 */
export type RegisterResponse = {
	id: string;
	email: string;
};

/**
 * This are roles that can be assigned to a user
 */
export enum SystemRole {
	PLATFORM_MANAGER = "PLATFORM_MANAGER",
	USER = "USER",
}

/**
 * This is the payload of the JWT token
 */
export type JWTPayload = {
	uid: string;
	email: string;
	displayName: string;
	systemRoles: SystemRole[];
	iat: number;
	exp: number;
	emailVerified: boolean;
};

export interface PlanLimits {
	monthlyCoins: number;
	maxChats: number;
	maxStorageEpisodes: number;
	features: {
		chapterSharing: boolean;
		wholePodcastSharing: boolean;
		batchCreation: boolean;
		retainAccess: boolean;
	};
}

// the usr type is just the jwt payload extended with profile data
export type User = JWTPayload & {
	limits?: PlanLimits;
	coinBalance?: number;
	subscriptionStatus?: string;
	currentPlanId?: string;
	subscriptionEndsAt?: string | null;
	subscriptionId?: string | null;
	isAnonymous?: boolean;
	hasSelectedInitialPlan?: boolean;
	hasUsedSubscriptionTrial?: boolean;
	engagementEmailsEnabled?: boolean;
	marketingEmailsEnabled?: boolean;
};

/**
 * Email notification preferences (GDPR opt-out for non-transactional mail).
 */
export type NotificationPreferences = {
	engagementEmailsEnabled: boolean;
	marketingEmailsEnabled: boolean;
};
